// extracted by mini-css-extract-plugin
export default {"title":"DeleteDialog_title__7TB79","dialogText":"DeleteDialog_dialogText__C0fWB","actionRow":"DeleteDialog_actionRow__-4-Gu"};